import { Injectable } from '@angular/core';
import { HttpService } from '../providers/http.service';
import { AppConfig } from '../app/app.config';
@Injectable()
export class SendMessageService {
    constructor(
        private httpService: HttpService,
        private config: AppConfig
       ) { }

    //发消息
    //chen 2017-05-09
    sendMessage(params) {
        let url = AppConfig.GetProdUrl() + "/Message/Send";
        return this.httpService.post(url,params);
    }
    
    //获取用户直属下级列表
    //TQQ 2017-05-26
    getSubUserNames() {
        let url = AppConfig.GetProdUrl() + '/User/GetSubUserNames';
        return this.httpService.get(url);
    }
}


// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./node_modules/angular2-template-loader!./node_modules/tslint-loader??ref--7-0!./src/services/sendMessage.service.ts